import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['glyph']

  connect() {
    this._fit = () => this.fitAll()
    this._fit()
    this.resizeObserver = new ResizeObserver(this._fit)
    this.resizeObserver.observe(this.element)
  }

  disconnect() {
    this.resizeObserver?.disconnect()
  }

  fitAll() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.glyphTargets.forEach((glyph) => {
        glyph.style.transform = ''
      })
      return
    }

    this.glyphTargets.forEach((glyph) => {
      glyph.style.transform = ''
      const parent = glyph.parentElement
      if (!parent) return

      const available = parent.clientWidth
      const needed = glyph.scrollWidth
      if (needed <= available || available <= 0) return

      const scale = Math.max(0.55, available / needed)
      glyph.style.transform = `scale(${scale})`
    })
  }
}
